import { Menu, MenuItem, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, TextField, Grid, Card, CardActionArea, CardContent, Typography, Tooltip } from "@mui/material";
import React, { Fragment, useState } from "react";
import { useASContext } from "../../controllers/context-api/as-context";
import AddNewOrganization from "./add-new-org/add-new-org";
import { UserRoleIds } from "../../constants/app-enum";
import { ASButton } from "../../shared/as-button/as-button";
import jwtDecode from "jwt-decode";
import './tenants-menu.scss';

const TenantsMenu = (props) => {
    const asContext = useASContext();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input

    const { isOwner, tenants, isMenuOpen, closeTenantMenu, tenantAnchorEl, isIndividualUser, setSavedOrganization, refresh_token } = props;

    const userRoleIds = UserRoleIds(); // Get UserRoleIds from app-enum.js

    const handleShowMoreClick = () => {
        setIsDialogOpen(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };

    // Filter tenants based on the search query
    const filteredTenants = tenants?.filter((tenant) =>
        tenant?.Name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    let accessToken = localStorage.getItem('token');
    const decodedToken = jwtDecode(accessToken);
    const ownerTenantUId = decodedToken?.ASTenantUId;
    const isAgencyClient = ((asContext?.tenants?.selectedTenant?.AgencyUId) && (asContext?.tenants?.selectedTenant?.ASTenantId != ownerTenantUId));
    

    return (
        <Fragment>
            <Menu
                open={isMenuOpen}
                anchorEl={tenantAnchorEl}
                className="tenants-menu"
                area-aria-haspopup="false"
                onMouseLeave={closeTenantMenu}
                keepMounted={false}
                onClose={closeTenantMenu}
                MenuListProps={{
                    onMouseLeave: closeTenantMenu,
                }}
            >
                {tenants?.length > 5 ? (
                    <>
                        <MenuItem
                            onClick={() => props.selectTenant(asContext?.tenants?.selectedTenant || tenants[0])}
                            className={"selected-tenant"}
                        >
                            {asContext?.tenants?.selectedTenant?.Name || tenants[0]?.Name}
                        </MenuItem>
                        <MenuItem onClick={handleShowMoreClick}>Show All Tenants</MenuItem>
                    </>
                ) : (
                    tenants?.map((tenant, index) => (
                        <MenuItem
                            onClick={() => props.selectTenant(tenant)}
                            className={
                                tenant?.ASTenantId === asContext?.tenants?.selectedTenant?.ASTenantId
                                    ? "selected-tenant"
                                    : ""
                            }
                            key={index}
                        >
                            {tenant?.Name}
                        </MenuItem>
                    ))
                )}

                {props.remainingTenantFeatureBalance > 0 && !isIndividualUser && isOwner  && !isAgencyClient ? (
                    <MenuItem onClick={(event) => props.routeToAddNewOrganization(event)}>
                        Add New Organization
                    </MenuItem>
                ) : null}
            </Menu>

            {/* Dialog for showing all tenants */}
            <Fragment>
                <Dialog
                    open={isDialogOpen}
                    onClose={handleDialogClose}
                    fullWidth
                    className="tenants-menu-dialog"
                    PaperProps={{
                        style: {
                            maxHeight: "75vh",
                            minHeight: "75vh",
                        },
                    }}
                >
                    <DialogTitle>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>All Tenants</span>
                            {props.remainingTenantFeatureBalance > 0 && !isIndividualUser && isOwner && !isAgencyClient && (
                                <ASButton
                                    primary={true}
                                    variant="outlined"
                                    onClick={(event) => props.routeToAddNewOrganization(event)}
                                    className="add-organization-button"
                                >
                                    Add New Organization
                                </ASButton>
                            )}
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            placeholder="Search tenants..."
                            variant="outlined"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{ margin: "10px 0" }}
                            InputProps={{
                                style: {
                                    borderColor: "#333",
                                    boxShadow: "none",
                                }
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "#333",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#333",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#333",
                                    },
                                },
                            }}
                        />
                        <div style={{ maxHeight: "50vh", overflowY: "auto", paddingRight: "10px" }}>
                            <Grid container spacing={2}>
                                {filteredTenants?.map((tenant, index) => {
                                    const matchedRole = Object.keys(userRoleIds).find(
                                        (key) => userRoleIds[key] === tenant.UserRoleId
                                    );

                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Card
                                                className={
                                                    tenant?.ASTenantId === asContext?.tenants?.selectedTenant?.ASTenantId
                                                        ? "selected-tenant-card tenant-card"
                                                        : "tenant-card"
                                                }
                                            >
                                                <CardActionArea onClick={() => {
                                                    props.selectTenant(tenant);
                                                    handleDialogClose();
                                                }}>
                                                    <CardContent>
                                                        <Tooltip
                                                            title={tenant?.Name}
                                                            placement="top"
                                                            arrow
                                                            disableInteractive
                                                            PopperProps={{
                                                                disablePortal: true,
                                                                modifiers: [
                                                                    {
                                                                        name: "preventOverflow",
                                                                        options: {
                                                                            boundary: "window",
                                                                        },
                                                                    },
                                                                ],
                                                            }}
                                                        >
                                                            <Typography variant="h6" className="tenant-name">
                                                                {tenant?.Name}
                                                            </Typography>
                                                        </Tooltip>

                                                        <Typography variant="body2" className="tenant-role-text">
                                                            {matchedRole || "Unknown Role"}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Grid>
                                    );
                                })}

                                {filteredTenants?.length === 0 && (
                                    <Grid item xs={12}>
                                        <Typography variant="body1" align="center">No tenants found</Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    </DialogContent>
                </Dialog>
            </Fragment>
            <AddNewOrganization
                open={props.isDialogOpen}
                onClose={props.handleCloseDialog}
                setSavedOrganization={setSavedOrganization}
                refresh_token={refresh_token}
            />
        </Fragment>
    );
};

export default TenantsMenu;